var map = {
	"./Day-Care-Center-1-300x225.jpg": 8300,
	"./Day-Care-Center-2-300x225.jpg": 2743,
	"./Day-Care-Center-3-300x225.jpg": 2,
	"./Day-Care-Center-4-300x225.jpg": 9597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9594;